import { EXAMPLE_FORM } from '../constants/formNames';

const submitExampleForm = (values, dispatch) => {
  dispatch({
    type: 'POST_EXAMPLE',
    meta: {
      formName: EXAMPLE_FORM
    },
    payload: values
  });
};

export default submitExampleForm;
